import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const CrossedIcon = (props) => {
  return (
  /*  <svg
      className= {props.selected ? "svgEditorSelected": "svgEditor"}
      height="13"
      viewBox="0 0 1792 1792"
      width="13"
      style={ { paddingTop:"2px", paddingLeft:"2px" } }
      >
     
      <path d="M1760 896q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1728zm-1277-64q-28-35-51-80-48-97-48-188 0-181 134-309 133-127 393-127 50 0 167 19 66 12 177 48 10 38 21 118 14 123 14 183 0 18-5 45l-12 3-84-6-14-2q-50-149-103-205-88-91-210-91-114 0-182 59-67 58-67 146 0 73 66 140t279 129q69 20 173 66 58 28 95 52h-743zm507 256h411q7 39 7 92 0 111-41 212-23 55-71 104-37 35-109 81-80 48-153 66-80 21-203 21-114 0-195-23l-140-40q-57-16-72-28-8-8-8-22v-13q0-108-2-156-1-30 0-68l2-37v-44l102-2q15 34 30 71t22.5 56 12.5 27q35 57 80 94 43 36 105 57 59 22 132 22 64 0 139-27 77-26 122-86 47-61 47-129 0-84-81-157-34-29-137-71z"/>
     
     
    </svg>
*/
<svg className= {props.selected ? "svgEditorSelected": "svgEditor"} version="1.0" xmlns="http://www.w3.org/2000/svg"
width="8.000000pt" height="8.000000pt" viewBox="0 0 450.000000 450.000000"
preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,450.000000) scale(0.100000,-0.100000)"
 stroke="none">
<path d="M2338 4674 c-535 -65 -961 -322 -1138 -688 -80 -165 -105 -296 -97
-508 6 -170 27 -259 93 -395 l44 -93 648 1 c475 0 640 3 622 11 -219 95 -403
207 -464 281 -160 195 -107 475 116 618 215 138 641 144 866 13 76 -44 166
-138 200 -207 33 -67 62 -164 62 -208 0 -15 3 -41 6 -58 l7 -31 423 0 424 0 0
58 c0 147 -56 358 -135 510 -146 282 -429 509 -774 621 -256 84 -596 112 -903
75z"/>
<path d="M0 2415 l0 -285 1373 0 1372 0 77 -29 c175 -68 326 -163 387 -244 60
-79 76 -140 76 -282 0 -113 -2 -124 -31 -185 -53 -112 -120 -171 -255 -226
-104 -43 -189 -56 -359 -55 -157 0 -287 16 -385 47 -158 51 -292 161 -357 294
-40 81 -78 220 -78 287 0 79 37 73 -433 73 l-420 0 6 -108 c27 -470 278 -837
727 -1062 189 -94 378 -152 610 -187 164 -25 553 -25 705 0 531 87 885 316
1048 678 69 152 92 288 84 501 -6 176 -33 303 -92 425 l-34 73 549 0 550 0 0
285 0 285 -2560 0 -2560 0 0 -285z"/>
</g>
</svg>

  );
};

export default CrossedIcon;
